import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76e052e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "custom-cover-container" }
const _hoisted_3 = {
  key: 0,
  class: "custom-cover-preview"
}
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "cover-overlay" }
const _hoisted_6 = { class: "custom-cover-container" }
const _hoisted_7 = {
  key: 0,
  class: "custom-cover-preview"
}
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = { class: "cover-overlay" }
const _hoisted_10 = { class: "itemModal" }
const _hoisted_11 = { style: {"font-size":"16px"} }
const _hoisted_12 = { class: "dialog-footer" }

import {searchFormConfig} from './config/search.config'
import {contentTableConfig} from './config/content.config'
import {modalConfig} from './config/modal.config'
import {usePageSearch} from '@/hooks/userPageSearch'
import {usePageModal} from '@/hooks/usePageModal'
import {ref} from 'vue'
import PageSearch from '@/components/PageSearch.vue'
import PageContent from '@/components/PageContent.vue'
import PageModal from '@/components/PageModal.vue'
import {useStore} from '@/store'
import {useUpload} from "@/hooks/useUpload";
import {getPageListData, postData} from "@/service/main/system";
import {ElMessage, ElMessageBox} from "element-plus";


export default /*#__PURE__*/_defineComponent({
  __name: 'Product',
  setup(__props) {

const store = useStore()

let eventData = ref()
const getEventList = async () => {
  eventData = await getPageListData(
    '/main/customerEvents/queryByCondition',
    {
      pageNo: 1,
      pageSize: 1000
    }
  )

  const channels = searchFormConfig.formItems.find(
    (item) => item.field === 'liveRoom'
  )

  const modelChannels = modalConfig.formItems.find(
    (item) => item.field === 'liveRoom'
  )

  channels!.options = eventData.list.map((item: any) => {
    return {title: item.eventName, value: item.unionId}
  })

  modelChannels.options = eventData.list.map((item: any) => {
    return {title: item.eventName, value: item.unionId}
  })
}
getEventList()

const modalTitle = ref('新增')
const newCb = () => {
  modalTitle.value = '新增'
}

const editCb = () => {
  modalTitle.value = '编辑'
}

const [pageModalRef, defaultInfo, handleNewData, handleEditData] = usePageModal(
  newCb,
  editCb
)

let productId = ''
const articleData = (row: any) => {
  productId = row.id
}

const uploadSuccess = () => {
  postData("/main/product/uploadCover", {id: productId, cover: files.value[0]})
  files.value = []
  setTimeout(() => {
    const queryInfo = store.state.system.queryInfo
    pageContentRef.value?.getPageData(queryInfo)
  }, 1000)
}

const uploadExceed = () => {
  ElMessage.error('只能上传一张图片')
}

const deleteCover = async (row: any) => {
  ElMessageBox.confirm('确认删除商品图片？', '提示', {
    confirmButtonText: '确认',
    cancelButtonText: '取消',
    type: 'error',
    center: true
  }).then(() => {
    postData("/main/product/deleteCover", {id: row.id})
    setTimeout(() => {
      const queryInfo = store.state.system.queryInfo
      pageContentRef.value?.getPageData(queryInfo)
    }, 1000)
  })
}


const qrCodeData = (row: any) => {
  productId = row.id
}

const uploadQrCodeSuccess = () => {
  postData("/main/product/uploadQrCode", {id: productId, qrCode: files.value[0]})
  files.value = []
  setTimeout(() => {
    const queryInfo = store.state.system.queryInfo
    pageContentRef.value?.getPageData(queryInfo)
  }, 1000)
}

const uploadQrCodeExceed = () => {
  ElMessage.error('只能上传一张图片')
}

const deleteQrCode = async (row: any) => {
  ElMessageBox.confirm('确认删除支付二维码？', '提示', {
    confirmButtonText: '确认',
    cancelButtonText: '取消',
    type: 'error',
    center: true
  }).then(() => {
    postData("/main/product/deleteQrCode", {id: row.id})
    setTimeout(() => {
      const queryInfo = store.state.system.queryInfo
      pageContentRef.value?.getPageData(queryInfo)
    }, 1000)
  })
}

const tipDialogVisible = ref(false)
let queryItemInfo = {}
let changeInfo = ref()
let moduleType = ''
const changeVisibleStats = (item: any, type: any) => {
  if (item.id != undefined) {
    tipDialogVisible.value = true
    changeInfo.value = item
    moduleType = type
  }
}

const tipDialog = async (item: boolean): Promise<void> => {
  try {
    if (item) {
      console.log(moduleType)
      if (moduleType === '0') {  // 上架状态
        queryItemInfo = {
          id: changeInfo.value.id,
          isShow: changeInfo.value.isShow
        };
        await postData('/main/product/uploadVisible', queryItemInfo);
      } else {  // 热卖状态
        queryItemInfo = {
          id: changeInfo.value.id,
          hotSell: changeInfo.value.hotSell,
          liveRoom: changeInfo.value.liveRoom
        }
        await postData('/main/product/hotSell', queryItemInfo);
      }
    }
  } catch (error) {
    if (moduleType === '0') {
      console.error('调整当前商品"上架"状态失败:', error);
    } else {
      console.error('调整当前商品"热卖"状态失败:', error);
    }
  } finally {
    tipDialogVisible.value = false;
  }
}

const initData = () => {
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}

const [pageContentRef, handleResetClick, handleSearchClick] = usePageSearch()
const [uploadRef, extraData, files, action, beforeUpload, proveUpload, onSuccess, onExceed] = useUpload()

return (_ctx: any,_cache: any) => {
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "product",
      deleteTip: "确认删除此项吗？",
      onNewBtnClick: _unref(handleNewData),
      onEditBtnClick: _unref(handleEditData)
    }, {
      isShow: _withCtx((scope) => [
        _createVNode(_component_el_switch, {
          modelValue: scope.row.isShow,
          "onUpdate:modelValue": ($event: any) => ((scope.row.isShow) = $event),
          "active-value": "1",
          "inactive-value": "0",
          onChange: ($event: any) => (changeVisibleStats(scope.row, '0'))
        }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
      ]),
      hotSell: _withCtx((scope) => [
        _createVNode(_component_el_switch, {
          modelValue: scope.row.hotSell,
          "onUpdate:modelValue": ($event: any) => ((scope.row.hotSell) = $event),
          "active-value": "1",
          "inactive-value": "0",
          onChange: ($event: any) => (changeVisibleStats(scope.row, '1'))
        }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
      ]),
      liveRoom: _withCtx((scope) => [
        (_unref(eventData) && _unref(eventData).list)
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_unref(eventData).list.find(item => item.unionId === scope.row.liveRoom).eventName), 1))
          : _createCommentVNode("", true)
      ]),
      buyLink: _withCtx((scope) => [
        _createVNode(_component_el_link, {
          href: scope.row.buyLink,
          type: "primary",
          target: "_blank",
          underline: false
        }, {
          default: _withCtx(() => [
            _createTextVNode("点击访问")
          ]),
          _: 2
        }, 1032, ["href"])
      ]),
      cover: _withCtx((scope) => [
        _createElementVNode("div", _hoisted_2, [
          (scope.row.cover != null && scope.row.cover != '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("img", {
                  src: scope.row.cover,
                  alt: _ctx.商品图片
                }, null, 8, _hoisted_4),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_el_button, {
                    type: "danger",
                    size: "mini",
                    onClick: _withModifiers(($event: any) => (deleteCover(scope.row)), ["stop"])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("删除 ")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ])
              ]))
            : (_openBlock(), _createBlock(_component_el_upload, {
                key: 1,
                ref_key: "uploadRef",
                ref: uploadRef,
                multiple: "",
                "auto-upload": true,
                action: _unref(action),
                data: _unref(extraData),
                "before-upload": _unref(beforeUpload),
                "list-type": "text",
                accept: ".jpg, .jpeg, .png",
                "on-success": uploadSuccess,
                "on-exceed": uploadExceed,
                limit: 1
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    size: "mini",
                    type: "success",
                    onClick: ($event: any) => (articleData(scope.row))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 上传图片 ")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 2
              }, 1032, ["action", "data", "before-upload"]))
        ])
      ]),
      payQrCode: _withCtx((scope) => [
        _createElementVNode("div", _hoisted_6, [
          (scope.row.payQrCode != null && scope.row.payQrCode != '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("img", {
                  src: scope.row.payQrCode,
                  alt: _ctx.支付二维码
                }, null, 8, _hoisted_8),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_el_button, {
                    type: "danger",
                    size: "mini",
                    onClick: _withModifiers(($event: any) => (deleteQrCode(scope.row)), ["stop"])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("删除 ")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ])
              ]))
            : (_openBlock(), _createBlock(_component_el_upload, {
                key: 1,
                ref_key: "uploadRef",
                ref: uploadRef,
                multiple: "",
                "auto-upload": true,
                action: _unref(action),
                data: _unref(extraData),
                "before-upload": _unref(beforeUpload),
                "list-type": "text",
                accept: ".jpg, .jpeg, .png",
                "on-success": uploadQrCodeSuccess,
                "on-exceed": uploadQrCodeExceed,
                limit: 1
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    size: "mini",
                    type: "success",
                    onClick: ($event: any) => (qrCodeData(scope.row))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 上传图片 ")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 2
              }, 1032, ["action", "data", "before-upload"]))
        ])
      ]),
      _: 1
    }, 8, ["contentTableConfig", "onNewBtnClick", "onEditBtnClick"]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_el_dialog, {
        modelValue: tipDialogVisible.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((tipDialogVisible).value = $event)),
        title: "变更提醒",
        width: "20%",
        "destroy-on-close": "",
        center: "",
        onClose: initData
      }, {
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_el_button, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (tipDialog(false)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("取消")
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (tipDialog(true)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("确认")
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(moduleType) === '0' ? '是否调整当前商品 "上架" 状态？' : '是否调整当前商品 "热卖" 状态？'), 1)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createVNode(PageModal, {
      ref_key: "pageModalRef",
      ref: pageModalRef,
      defaultInfo: _unref(defaultInfo),
      modalConfig: _unref(modalConfig),
      title: modalTitle.value,
      pageName: "product",
      validOtherInfo: () => true
    }, null, 8, ["defaultInfo", "modalConfig", "title"])
  ]))
}
}

})